<div class="spinner-background">
  <div class="spinner-container">
    <div *ngIf="openingTvShop">
      <img src="https://www2.telenet.be/etc/designs/telenet-be/media/logos/telenet_logo.png" width="120" height="120" alt="">
      <div class="spinner-title" [translate]="descriptionSpinner"></div>
    </div>
		<div class="spinner">
			<svg version="1.1"
				id="svg-loader-1"
				xmlns="http://www.w3.org/2000/svg"
				x="0px"
				y="0px"
				viewBox="0 0 158.93 158.96"
				xml:space="preserve">
				<path
					id="spinner"
					fill="#FFFFFF"

					d="M79.4,141c-40.1-0.4-70.1-39.1-59.2-78.1c10.7-38.4,56.4-56.7,90.7-36.3c18.7,11.1,29.9,31.3,30.1,52.9
				c0.1,11.6,18.1,11.6,18,0c-0.2-24.8-11.7-48.1-31.4-63.2c-19.5-15-45.7-20-69.4-13.4c-23.5,6.5-42.8,24-52.2,46.5
				C-3.5,72.1-1.6,98.8,11,120c14.3,24.1,40.5,38.7,68.4,39C91,159.1,91,141.1,79.4,141L79.4,141z">
			    <animateTransform
			          attributeType="xml"
			          attributeName="transform"
			          type="rotate"
			          from="0 79.465 79.48"
			          to="360 79.465 79.48"
			          dur="1s"
			          repeatCount="indefinite"/>
				</path>
			</svg>
		</div>
	</div>
</div>
